/**
 * The initial/default values the used-search-options vuex store uses for userOptions
 */
export default function() {
    return {
        minPayment: 0,
        maxPayment: 1000,
        minInitialRental: 0,
        maxInitialRental: 5000,
        term: 48,
        mileage: [],
        manufacturer: [],
        model: [],
        fuelType: [],
        bodystyle: [],
        transmission: [],
        co2: null,
        sortBy: 'priceLowest',
        type: [],
        exclusiveOffers: false,
        page: 1,
        pageSize: 12,
    };
}